// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3KDlJ","errorLogs":"EditorFooter_errorLogs__koMsN"};